import { useState } from 'react';
import { CheckCircleOutlined } from '@ant-design/icons';
import { useBoolean } from 'ahooks';
import {
  Button,
  Modal,
  Radio,
  Row,
  Space,
} from 'antd';

import { MilesText } from 'components';

import { useGetRequest } from 'hooks';

import { ClaimFeedbacks, SnapClaimUnflagRequest } from 'codegen';
import { TRequestCallback } from 'types';

export const ConfirmButton = ({
  loading,
  handleClaim,
}: {
  loading: boolean;
  handleClaim: TRequestCallback<SnapClaimUnflagRequest>;
}) => {
  const [isOpen, { setFalse, setTrue }] = useBoolean();
  const [feedbackId, setClaimId] = useState(0);

  const { data, loading: feeedbacksLoading } = useGetRequest<ClaimFeedbacks>({
    url: '/claims/feedbacks',
    queryParams: {
      status: 'ACTIVE',
      resolutionStatus: ['CONFIRMED', 'PARTIALLY_CONFIRMED'],
    },
    options: {
      ready: isOpen,
    },
  });

  const feedbacks = data?.feedbacks;
  const status = feedbacks?.find(({ id }) => feedbackId === id)?.resolutionStatus;

  return (
    <>
      <Modal
        open={isOpen}
        title='Confirm The Claim'
        okText='Confirm'
        confirmLoading={loading || feeedbacksLoading}
        onOk={() => handleClaim({ payload: { feedbackId, resolutionStatus: status as SnapClaimUnflagRequest.resolutionStatus } })}
        onCancel={setFalse}
        afterClose={() => setClaimId(0)}
        cancelButtonProps={{ loading: loading || feeedbacksLoading }}
        okButtonProps={{
          icon: <CheckCircleOutlined />,
          disabled: !feedbackId,
          loading: loading || feeedbacksLoading,
          className: 'bg-green-500',
        }}
      >
        <Row className='mb-10'>
          <MilesText>
            To send proceed with claim resolution please select one option from the list:
          </MilesText>
        </Row>

        <Radio.Group
          value={feedbackId}
          onChange={({ target }) => setClaimId(target.value)}
        >
          <Space direction='vertical'>
            {feedbacks?.map(({ id, resolutionReason }) => (
              <Radio key={id} value={id}>{resolutionReason}</Radio>
            ))}
          </Space>
        </Radio.Group>
      </Modal>

      <Button
        size='small'
        type='primary'
        icon={<CheckCircleOutlined />}
        onClick={setTrue}
        loading={loading}
        className='bg-green-500'
      >
        Confirm
      </Button>
    </>
  );
};
